import type { TAccountState } from '@/types/state-types'

export default {
  isUserLoggedIn(state: TAccountState) {
    return Boolean(state.userId && state.accessToken)
  },
  hasProfileInfo(state: TAccountState): boolean {
    return !!state.profile
  }
}
